// ============================================
// Creator Events - Editor (ES6)
// 캐릭터 에디터 모달 이벤트
// ============================================

import {
  closeEditor, switchEditorTab, showEditorMenu,
  setIntroType, addIntroBlock, addIntroImage,
  autoFillScenario, saveDraft, publishCreation,
  openImageModal,
  openExampleDialogueModal, deleteExample
} from '../index.js';
import {
  openEditorImageSheet, closeEditorImageSheet,
  uploadFromDevice, openLibrarySheet, closeLibrarySheet,
  handleLibraryImageClick, closeLibraryDetail,
  downloadLibraryImage, applyLibraryImage, openLibraryForTransformSource
} from '../image-gallery.js';

// ============================================
// 유틸리티
// ============================================

function insertTextAtCursor(inputId, text) {
  const input = document.getElementById(inputId);
  if (!input) return;

  const start = input.selectionStart;
  const end = input.selectionEnd;
  const value = input.value;

  input.value = value.substring(0, start) + text + value.substring(end);
  input.selectionStart = input.selectionEnd = start + text.length;
  input.focus();
}

// ============================================
// 캐릭터 에디터 모달 이벤트
// ============================================

export function initCharacterEditorEvents() {
  const modal = document.getElementById('characterEditorModal');
  if (!modal) return;

  // 닫기 버튼
  modal.querySelector('.editor-close-btn')?.addEventListener('click', closeEditor);

  // 자동채우기 버튼
  modal.querySelector('.editor-autofill-btn')?.addEventListener('click', autoFillScenario);

  // 임시저장 버튼
  modal.querySelector('.editor-draft-btn')?.addEventListener('click', saveDraft);

  // 등록 버튼
  modal.querySelector('.editor-publish-btn')?.addEventListener('click', publishCreation);

  // 메뉴 버튼
  modal.querySelector('.editor-menu-btn')?.addEventListener('click', (e) => showEditorMenu(e));

  // 에디터 탭 (이벤트 위임)
  modal.querySelector('.editor-tabs')?.addEventListener('click', (e) => {
    const tab = e.target.closest('.editor-tab');
    if (tab) {
      const tabName = tab.dataset.editorTab;
      if (tabName) switchEditorTab(tabName);
    }
  });

  // 이미지 추가 버튼 → 바텀시트 열기
  document.getElementById('editorImageAddBtn')?.addEventListener('click', openEditorImageSheet);

  // 에디터 이미지 액션 바텀시트 이벤트 위임
  document.getElementById('editorImageActionSheet')?.addEventListener('click', (e) => {
    const action = e.target.closest('[data-action]')?.dataset.action;
    switch (action) {
      case 'closeEditorImageSheet':
        closeEditorImageSheet();
        break;
      case 'uploadFromDevice':
        document.getElementById('editorDirectImageInput')?.click();
        break;
      case 'openImageGenModal':
        closeEditorImageSheet();
        openImageModal();
        break;
      case 'openLibrarySheet':
        openLibrarySheet();
        break;
    }
  });

  // 직접 업로드 input
  document.getElementById('editorDirectImageInput')?.addEventListener('change', uploadFromDevice);

  // 라이브러리 바텀시트 이벤트 위임
  document.getElementById('libraryBottomSheet')?.addEventListener('click', (e) => {
    const action = e.target.closest('[data-action]')?.dataset.action;
    const index = e.target.closest('[data-index]')?.dataset.index;

    switch (action) {
      case 'closeLibrarySheet':
        closeLibrarySheet();
        break;
      case 'selectLibraryImage':
        if (index !== undefined) handleLibraryImageClick(parseInt(index));
        break;
    }
  });

  // 라이브러리 상세 모달 이벤트 위임
  document.getElementById('libraryImageDetailModal')?.addEventListener('click', (e) => {
    const action = e.target.closest('[data-action]')?.dataset.action;
    switch (action) {
      case 'closeLibraryDetail':
        closeLibraryDetail();
        break;
      case 'downloadLibraryImage':
        downloadLibraryImage();
        break;
      case 'applyLibraryImage':
        applyLibraryImage();
        break;
    }

    // 오버레이 클릭 시 닫기
    if (e.target.classList.contains('modal-overlay')) {
      closeLibraryDetail();
    }
  });

  // 인트로 타입 탭 (이벤트 위임)
  modal.querySelector('.intro-type-tabs')?.addEventListener('click', (e) => {
    const tab = e.target.closest('.intro-type-tab');
    if (tab) {
      const type = tab.dataset.type;
      if (type) setIntroType(type);
    }
  });

  // 인트로 이미지 버튼
  modal.querySelector('.intro-image-btn')?.addEventListener('click', addIntroImage);

  // 인트로 추가 버튼
  modal.querySelector('.intro-add-btn')?.addEventListener('click', addIntroBlock);

  // 인트로 삽입 버튼 ({{user}}, * 등)
  const introInputBar = modal.querySelector('#editorTabIntro .intro-input-bar');
  if (introInputBar) {
    introInputBar.addEventListener('click', (e) => {
      const insertBtn = e.target.closest('.intro-insert-btn');
      if (insertBtn) {
        const insertText = insertBtn.dataset.insert;
        insertTextAtCursor('introComposerInput', insertText);
      }
    });
  }

  // 대화 예시 추가 버튼
  document.getElementById('addExampleDialogueBtn')?.addEventListener('click', () => {
    openExampleDialogueModal(null);
  });

  // 대화 예시 리스트 이벤트 위임
  document.getElementById('exampleDialogueList')?.addEventListener('click', (e) => {
    // 삭제 버튼
    const deleteBtn = e.target.closest('[data-action="delete-example"]');
    if (deleteBtn) {
      e.stopPropagation();
      const index = parseInt(deleteBtn.dataset.index);
      deleteExample(index);
      return;
    }

    // 아이템 클릭 (편집)
    const item = e.target.closest('.example-dialogue-item');
    if (item) {
      const index = parseInt(item.dataset.index);
      openExampleDialogueModal(index);
    }
  });
}
